(() => {
 function init(root=document){root.querySelectorAll('[data-eyre-buy-now]').forEach(button=>{
 if(button.dataset.ready)return;button.dataset.ready='true';button.hidden=false;
 const form=button.closest('form'); const add=form.querySelector('[name="add"]');
 const error=form.querySelector('[data-eyre-buy-error]');
 const sticky=document.querySelector('[name="eyre_sticky_buy"][form="'+form.getAttribute('id')+'"]');
 if(sticky&&!sticky.dataset.ready){sticky.dataset.ready='true';sticky.addEventListener('click',()=>button.click());}
 const syncSticky=()=>{if(sticky){sticky.disabled=button.disabled;sticky.setAttribute('aria-busy',button.dataset.busy?'true':'false');}};
 new MutationObserver(syncSticky).observe(button,{attributes:true,attributeFilter:['disabled','data-busy']});
 form.classList.add('eyre-checkout-enabled');
 const sync=()=>{if(!button.dataset.busy)button.disabled=add.disabled||add.getAttribute('aria-disabled')==='true';};
 new MutationObserver(sync).observe(add,{attributes:true,attributeFilter:['disabled','aria-disabled']});sync();syncSticky();
 button.addEventListener('click',async()=>{
 if(button.disabled||button.dataset.busy)return;
 const variant=form.querySelector('[name="id"]');if(!variant||variant.disabled)return;
 const variantId=variant.value||button.dataset.variant;
 if(!variantId){error.textContent='Please select a product option before buying.';return;}
 button.dataset.busy='true';button.disabled=true;add.disabled=true;error.textContent='';button.textContent='Opening checkout…';
 const base=button.dataset.root;
 try{
 const response=await fetch(base+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
 if(!response.ok)throw new Error('Could not check your cart. Please try again.');
 const cart=await response.json();
 if(!cart.items.some(item=>String(item.variant_id)===variantId)){
 const result=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})});
 const data=await result.json();if(!result.ok)throw new Error(data.description||'Could not add this product. Please try again.');
 }
 window.location.assign(base+'checkout');
 }catch(e){error.textContent=e.message||'Checkout could not open. Please try Add to cart.';delete button.dataset.busy;add.disabled=false;button.disabled=false;button.textContent='Buy';}
 });
 window.addEventListener('pageshow',()=>{if(button.dataset.busy){delete button.dataset.busy;button.textContent='Buy';add.disabled=false;}sync();});
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();
